<template>
  <div class="form-group position-relative mb-3">
    <b-form-input
      :id="inputId"
      v-model="model"
      :type="type"
      :placeholder="' '" 
      @focus="isFocused = true"
      @blur="isFocused = false"
      :class="'form-control'"
      v-bind="$attrs"
      v-on="$listeners"
      :readonly="readonly" 
    />
    <label :for="inputId" :class="{ 'label-floating': isFocused || model }">
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'VInputFlutuante',
  props: {
    value: [String, Number],
    label: String,
    type: {
      type: String,
      default: 'text'
    },
    id: String,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFocused: false
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    inputId() {
      return this.id || `input-${this._uid}`;
    }
  }
};
</script>

<style scoped>
/* Estilos para o label */
label {
  position: absolute;
  top: 0.4rem; /* Aumentei o valor para subir mais o label */
  left: 0.75rem;
  font-size: 1.1rem; /* Aumenta o tamanho da fonte do label */
  transition: all 0.3s ease; /* Mais suave */
  color: #6c757d;
  pointer-events: none;
  background-color: transparent; /* Mantém o fundo transparente */
  padding: 0 0.25rem;
}

/* Estilo quando o campo estiver em foco ou preenchido */
input:focus + label,
.label-floating {
  font-size: 0.9rem; /* Tamanho da fonte quando a label flutua */
  top: -0.6rem; /* Ajusta para flutuar */
  left: 0.75rem; /* Ajusta para o alinhamento */
  color: #495057; /* Cor de destaque */
  background-color: white; /* Fundo branco quando flutua para cobrir a borda */
  padding: 0 0.25rem; /* Alinha melhor */
}

/* Para melhorar a borda do input */
input.form-control {
  border: 1px solid #ced4da;
  padding: 0.75rem 1.25rem; /* Ajusta o padding para acomodar a label corretamente */
}

input.form-control:focus {
  border-color: #80bdff; /* Destaca a borda quando em foco */
  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.25); /* Adiciona um efeito de sombra */
}

/* Estilo para readonly - Remover fundo cinza e manter o visual */
input[readonly] {
  background-color: transparent !important; /* Remove fundo cinza */
  color: #495057; /* Mantém a cor do texto legível */
  border-color: #ced4da; /* Mantém a borda como nos campos editáveis */
}
</style>
